/** Compliance UI routes — kind lists + dashboard (Pulse-style section URLs). */
export const COMPLIANCE_BASE_PATH = '/compliance';
export const COMPLIANCE_DASHBOARD_PATH = '/compliance/dashboard';
export const COMPLIANCE_POLICIES_PATH = '/compliance/policies';
export const COMPLIANCE_PROTOCOLS_PATH = '/compliance/protocols';
export const COMPLIANCE_PLANS_PATH = '/compliance/plans';
/** @deprecated Prefer kind-scoped editor paths; kept for legacy redirects. */
export const COMPLIANCE_POLICY_PATH = '/compliance/dashboard/policy';

export type ComplianceArtifactKind = 'policy' | 'protocol' | 'plan';
export type CompliancePolicyIntent = 'edit' | 'applicability';

const KIND_LIST_PATH: Record<ComplianceArtifactKind, string> = {
  policy: COMPLIANCE_POLICIES_PATH,
  protocol: COMPLIANCE_PROTOCOLS_PATH,
  plan: COMPLIANCE_PLANS_PATH,
};

/** List page for an artifact kind. */
export function complianceKindListPath(kind: ComplianceArtifactKind): string {
  return KIND_LIST_PATH[kind];
}

/** Editor URL under the kind list (keeps the kind tab active via NavLink prefix). */
export function buildComplianceDocumentPath(
  kind: ComplianceArtifactKind,
  countryCode: string,
  requirementKey: string,
  intent: CompliancePolicyIntent = 'edit'
): string {
  const params = new URLSearchParams({ country: countryCode, requirementKey });
  if (intent === 'applicability') params.set('applicability', '1');
  return `${KIND_LIST_PATH[kind]}/item?${params.toString()}`;
}

/**
 * @deprecated Use buildComplianceDocumentPath with artifactKind.
 * Builds the policy editor URL, including optional applicability deep-link.
 */
export function buildCompliancePolicyPath(
  countryCode: string,
  requirementKey: string,
  intent: CompliancePolicyIntent = 'edit'
): string {
  return buildComplianceDocumentPath('policy', countryCode, requirementKey, intent);
}

/** Infer kind from requirementKey prefix when catalog row is unavailable. */
export function inferComplianceArtifactKind(requirementKey: string): ComplianceArtifactKind {
  if (requirementKey.startsWith('protocol.') || requirementKey.startsWith('company.protocol.')) {
    return 'protocol';
  }
  if (requirementKey.startsWith('plan.') || requirementKey.startsWith('company.plan.')) {
    return 'plan';
  }
  return 'policy';
}
